import styled from 'styled-components';

const StyledMenuContainer = styled.div`
	position: absolute;
	left: 60px;
	top: 142px;
	display: flex;
	flex-direction: column;
	gap: 10px;
`;

export { StyledMenuContainer };
